/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import cx from 'classnames';
import { Actionable, Text, View } from '@az/starc-ui';
import React from 'react';
import { formatNumber } from '../../../utils/formatNumber';
import styles from './styles.module.scss';
import { scrollToCustomerReviews } from '@/features/customReviews/utils/scrollToCustomerReviews';
import { useLabels } from '@/hooks/useLabels';
import { useForteDecisionFlagWithTrueDefault } from '@/features/forte/api/getForteDecision';

const labelMap = {
  rating: 'label_reviews_rating',
  ratings: 'label_reviews_ratings',
};

type RatingsReviewsCountProps = {
  ratingsCount: number;
  reviewsCount: string;
  variant?: 'default' | 'header';
};

export const RatingsReviewsCount = ({
  ratingsCount,
  reviewsCount,
  variant = 'default',
}: RatingsReviewsCountProps) => {
  const labels = useLabels(labelMap);
  const pdpRedesignEnabled = useForteDecisionFlagWithTrueDefault('pdpRedesignEnabled');

  const content = (
    <Text className={styles.ratingsAndReviewsContainer}>
      <Text
        variant="main-body"
        weight="bold"
        className={cx(styles.ratingsText, { [styles['--smallText']]: pdpRedesignEnabled })}
      >
        {formatNumber(ratingsCount)} {ratingsCount !== 1 ? labels.ratings : labels.rating}
      </Text>
      <Actionable onClick={scrollToCustomerReviews}>
        <Text
          variant="main-body"
          className={cx(styles.reviewCount, { [styles['--smallText']]: pdpRedesignEnabled })}
        >
          {reviewsCount}
        </Text>
      </Actionable>
    </Text>
  );

  if (variant === 'header') {
    return <View className={styles.headerContainer}>{content}</View>;
  }

  return <>{content}</>;
};
